import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import swal from "sweetalert";

import DropDown from '../../Components/DropDown/DropDown';
import Input from '../../Components/Input/Input';
import Message from '../../Components/Message/Message';
import Modal from '../../Components/Modal/Modal';
import { useTranslation } from 'react-i18next';

import { MdDeleteOutline } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { BsFilterLeft } from "react-icons/bs";
import { IoMdArrowDropdown, IoMdAdd  } from "react-icons/io";

import {get_all_suppliers, create_suppliers, update_supplier, delete_suppliers} from "../../context/Services/Suppliers";

const Suppliers = () => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	
	const [showModal, setShowModal] = useState(false);
	const [suppliers, setSuppliers] = useState([]);
	const [status, setStatus] = useState(false);
	const [loading, setLoading] = useState(true);
	const [isUpdating, setIsUpdating] = useState(false);

	const intial_payload = {
		supplier_name: "",
		product_type: "",
		total_amount:0,
		paied:0,
		owed:0,
		pay_date: Date.now(),
		note: "",
	};
	const [payload, setPayload] = useState(intial_payload);

	const handle_get_suppliers = () => {
		get_all_suppliers()
			.then(res => {
				setSuppliers(res?.data);
			})
			.catch(e => {
				console.log(e);
			})
	}

	const handle_delete_suppliers = async (id) => {

		const willDelete = await swal({
			title: "Es-vous sûr ?",
			text: "Eest ce que vous voulez vraiment supprimer ?",
			icon: "warning",
			buttons: true,
			dangerMode: true,
		});

		if(willDelete){
			delete_suppliers(id)
				.then(res => {
					handle_get_suppliers();
					setTimeout(()=>{
						 setStatus(false);
					}, 1500);
				})
				.catch(e => setStatus(false));
		}
	}

	const handle_update_supplier = async () => {
		const willUpdate = await swal({
			title: "Es-vous sûr ?",
			text: "Eest ce que vous voulez vraiment confirmer ?",
			icon: "warning",
			buttons: true,
			dangerMode: true,
		});

		if(willUpdate){
			update_supplier(payload?._id, payload)
				.then(res => {
					setPayload(intial_payload);
					setShowModal(false)
					setIsUpdating(false);
					setStatus(false);
					handle_get_suppliers();
				})
				.catch(e => {
					setStatus(false);
					setIsUpdating(false);
				});
		}
	}

	const handle_add_supplier = async () => {
		setStatus(true)
		create_suppliers(payload)
			.then(res => {
				setShowModal(false);
				handle_get_suppliers();
				setStatus(false);
				setPayload(intial_payload)
			})
			.catch(e => setStatus(false));
	}

	useEffect(() => {
		handle_get_suppliers();
	}, [])

	return (
		<>	
			<Message loading={status} status={{status: status}}/>

			<Modal showBakcDrop={showModal} modal={showModal} hideModal={()=>{setShowModal(false); setPayload(intial_payload)}} className="auto_width">
				<div className="grid full">
					<div className="flex flex-col full relative" style={{gap:"10px"}}>
						<h5>{t("Nome de fournisseur")}</h5>
						<Input 
						   placeholder="Nome de fournisseur" 
						   setChange={ (e)=> {
						   		setPayload(prev => ({...prev, supplier_name: e }))
						   }} 
						   value={payload.supplier_name}
						/>
					</div>

					<div className="flex flex-col full relative" style={{gap:"10px"}}>
						<h5>{t("Type de produit")}</h5>
						<Input 
						   placeholder="Type de produit" 
						   setChange={ (e)=> {
						   		setPayload(prev => ({...prev, product_type: e }))
						   }} 
						   value={payload.product_type}
						/>
					</div>

					<div className="flex flex-col full" style={{gap:"10px"}}>
						<h5>{t("Total")}</h5>
						<Input 
						   placeholder="Amount" 
						   setChange={ (e)=>setPayload(prev => ({...prev, total_amount: e})) } 
						   value={payload.total_amount}
						/>
					</div>

					<div className="flex flex-col full" style={{gap:"10px"}}>
						<h5>{t("Paied")}</h5>
						<Input 
						   placeholder="Amount" 
						   setChange={ (e)=>setPayload(prev => ({...prev, paied: e})) } 
						   value={payload.paied}
						/>
					</div>

					<div className="flex flex-col full" style={{gap:"10px", padding:"0px 0"}}>
						<h5>{t("Note")}</h5>
						<Input 
						   placeholder="Note" 
						   setChange={ (e)=>setPayload(prev => ({...prev, note: e})) } 
						   value={payload.note}
						/>
					</div>

					<div className="flex flex-col full" style={{gap:"10px", padding:"0px 0"}}>
						<h5>{t("Date de paiement")}</h5>
						<Input
						   type="date"
						   placeholder="Date de paiement" 
						   setChange={ (e)=>setPayload(prev => ({...prev, pay_date: e})) } 
						   value={payload.pay_date}
						/>
					</div>

					<button 
						className="filter_button full pointer two_span" 
						onClick={isUpdating ? handle_update_supplier : handle_add_supplier}
						style={{paddingTop: '10px', paddingBottom:"10px"}}
					>
						{t("Confirm")}
					</button>

				</div>
			</Modal>

			<div className="clients_overview latest_clients_overview shadow">
					<div className="chart_section_header flex items-center">
						<b>{t("Les fournisseur")}</b>
						<div className='relative to-right flex gap'>
							<div className="flex gap items-center filter_button" onClick={()=>{
								setShowModal(!showModal);
								setIsUpdating(false);
							}}>
								<IoMdAdd  style={{color:"#7983ff", fontSize:'1.2rem'}}/>
								<b>{t("Ajouter un fournisseur")}</b>
							</div>

						</div>
					</div>

					<div className="flex flex-col gap summary_clients_section">
						<div className="table_section table_section_overwrite">
							<table cellPadding="0" cellSpacing="0">
								<tbody>
									<td className="table-keys cell2 pointer">{t("Nome de fournisseur")}</td>
									<td className="table-keys cell2 pointer">{t("Type de produit")}</td>
									<td className="table-keys cell2 pointer">{t("Total")}</td>
									<td className="table-keys cell2 pointer">{t("Paied")}</td>
									<td className="table-keys cell2 pointer">{t("Date de paiement")}</td>
									<td className="table-keys cell2 pointer">{t("Action")}</td>

									{
										suppliers.length > 0 &&
										suppliers.map((elem, i) => (
											<tr className={`data-cells`} key={i}>
													<td className={`value2 cell2  `} >{elem?.supplier_name}</td>
													<td className={`value2 cell2  `} >{elem?.product_type}</td>
													<td className={`value2 cell2  `} >{elem?.total_amount}</td>
													<td className={`value2 cell2  `} >{elem?.paied}</td>
													<td className={`value2 cell2  `} >{elem?.pay_date.split("T")[0]}</td>
													<td className={`value2 cell2 action`}>
														<div className="flex gap_5 justify-center">
															<MdDeleteOutline className="action_btn delete" onClick={()=>handle_delete_suppliers(elem?._id)}/>
															<AiOutlineEdit className="action_btn edit" onClick={()=>{
																setPayload(elem);
																setShowModal(true);
																setIsUpdating(true);
															}}/>
														</div>
													</td>
											</tr>
										)) 
									}
									
								</tbody>
							</table>
						</div>

					</div>
			</div>
		</>
	)
}

export default Suppliers